(function () {
  "use strict";
  if (window.__tk9BackToSchool2026) return;
  window.__tk9BackToSchool2026 = true;

  var config = window.TeamK9BackToSchool2026 || {};
  var start = Date.parse(config.startsAt || "2026-08-13T04:00:28Z");
  var end = Date.parse(config.endsAt || "2026-08-18T03:59:59Z");
  var timer = null;

  function params() {
    try { return new URLSearchParams(window.location.search); }
    catch (error) { return { get: function () { return null; } }; }
  }

  function isActive() {
    var query = params();
    if (query.get("tk9_campaign_off") === "1") return false;
    if (query.get("tk9_campaign_preview") === "1") return true;
    var now = Date.now();
    return Number.isFinite(start) && Number.isFinite(end) && now >= start && now <= end;
  }

  window.TeamK9PromotionCheckoutPath = function (fallbackPath) {
    if (!isActive()) return fallbackPath || "/checkout";
    return "/checkout?discount=" + encodeURIComponent(config.code || "SCHOOL");
  };

  function setPeerHidden(selector, active) {
    document.querySelectorAll(selector).forEach(function (node) {
      if (active && !node.hidden) {
        node.hidden = true;
        node.setAttribute("data-tk9-bts-hidden-by-campaign", "1");
      } else if (!active && node.getAttribute("data-tk9-bts-hidden-by-campaign") === "1") {
        node.hidden = false;
        node.removeAttribute("data-tk9-bts-hidden-by-campaign");
      }
    });
  }

  function placePdpStrip(active) {
    var strip = document.querySelector("[data-tk9-bts-pdp]");
    if (!strip || !active) return;
    var form = document.querySelector('form[action*="/cart/add"], form.shopify-product-form');
    if (!form) return;
    var buyBlock = form.closest(".buy-buttons-block") || form;
    if (buyBlock.parentNode && buyBlock.nextElementSibling !== strip) {
      buyBlock.parentNode.insertBefore(strip, buyBlock.nextSibling);
    }
  }

  function bindCartCheckout(active) {
    var checkout = document.querySelector('#checkout, button[name="checkout"]');
    if (!checkout || !active) return;
    if (checkout.getAttribute("data-tk9-bts-checkout") === "1") return;
    checkout.setAttribute("data-tk9-bts-checkout", "1");
    checkout.addEventListener("click", function (event) {
      if (!isActive()) return;
      event.preventDefault();
      window.location.href = window.TeamK9PromotionCheckoutPath("/checkout");
    });
  }

  function pad(value) {
    value = Math.max(0, Number(value) || 0);
    return value < 10 ? "0" + value : String(value);
  }

  function updateCountdowns() {
    var remaining = Math.max(0, end - Date.now());
    var totalSeconds = Math.floor(remaining / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    document.querySelectorAll("[data-tk9-bts-countdown]").forEach(function (node) {
      var values = { days: days, hours: hours, minutes: minutes, seconds: seconds };
      Object.keys(values).forEach(function (key) {
        var target = node.querySelector("[data-tk9-bts-" + key + "]");
        if (target) target.textContent = pad(values[key]);
      });
    });
  }

  function render() {
    var active = isActive();
    document.documentElement.toggleAttribute("data-tk9-bts-active", active);
    document.querySelectorAll("[data-tk9-bts-surface]").forEach(function (node) {
      node.hidden = !active;
      node.setAttribute("aria-hidden", active ? "false" : "true");
    });
    setPeerHidden('[id$="__hero_section_legendary_TEV66M"]', active);
    placePdpStrip(active);
    bindCartCheckout(active);
    updateCountdowns();
    if (!active && Date.now() > end && timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  function startRuntime() {
    render();
    timer = window.setInterval(render, 1000);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", startRuntime, { once: true });
  else startRuntime();
  document.addEventListener("shopify:section:load", render);
})();
